import AutoCompleteInput from './AutoCompleteInput.vue';

export default AutoCompleteInput;
